import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "15", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "5", y1: "5", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "EqualNot";
const EqualNot = memo(themed(Icon));
export {
  EqualNot
};
//# sourceMappingURL=equal-not.js.map
